import { Typography } from 'antd'

import { titlesOf } from '@/Containers/TransportationSection/Components'

import type { KanbanCardRow, TransportRequestKanbanItem } from '@/Containers/TransportationSection/Components'

/**
 * Рядки картки канбану запиту під «Ід» (`SPEC-022` §8.2; підписи — `uk.json`):
 * «Назва» (обрізана), «Клієнт», «Тип авто» через «, », адреси. Порожнє — «-»,
 * як у легасі.
 */
export const requestKanbanRows = (item: TransportRequestKanbanItem): KanbanCardRow[] => [
    { label: 'Назва', value: item.title ? <Typography.Text ellipsis>{item.title}</Typography.Text> : '-' },
    { label: 'Клієнт', value: item.client?.title || '-' },
    { label: 'Тип авто', value: titlesOf(item.typesCars) || '-' },
    { label: 'Адреса зав.', value: item.addressLoading || '-' },
    { label: 'Адреса розв.', value: item.addressUnloading || '-' },
]
